import type { HTMLAttributes, KeyboardEvent } from 'react';

/**
 * Props cho dòng bảng bấm được để mở Drawer: chuột + bàn phím (Tab tới dòng, Enter / Space mở).
 * Dùng trong `onRow` của antd Table.
 */
export function rowOpenProps(label: string, open: () => void): HTMLAttributes<HTMLElement> {
  return {
    role: 'button',
    tabIndex: 0,
    'aria-label': label,
    onClick: open,
    onKeyDown: (e: KeyboardEvent<HTMLElement>) => {
      // Phím gõ trong phần tử con (nếu có) không mở Drawer.
      if (e.target !== e.currentTarget) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        open();
      }
    },
  };
}
